<!--
* 组件名 : 按钮
* 开发者 : JY
*
* 参数:
* className       {String}  []        - 按钮名字
* hasText         {Boolean} [false]   - 是否包含文字 如果按钮中包含问题，传入 true
* disabled        {Boolean} [false]   - 禁止点击状态 如果需要让按钮变成禁止状态，传入true
* linear          {Boolean} [false]   - 是否为线性按钮，传入true
* linearBoxName   {String}  []        - 线性盒子名称，执行js 用
*
*
*
* 事件:
* btnClick  [] - 按钮点击事件
-->

<template>
  <button
    :disabled="disabled"
    :class="['v-btn', className, linear ? 'linear-btn' : '']"
    :style="{ color: linear ? color : false }"
    @click.stop="btn_click"
    ref="vBtn"
  >
    <slot />
    <div
      v-if="linear"
      class="border-circle"
      ref="borderCircle"
      :style="{ borderColor: hex_to_rgb(color) }"
    >
      <svg
        width="50px"
        height="50px"
        viewBox="0 0 50 50"
        data-percent="100"
        ref="round"
      >
        <circle cx="25" cy="25" r="24" :style="{ stroke: color }" />
      </svg>
    </div>
  </button>
</template>

<script>
export default {
  name: "v-btn",
  data() {
    return {
      linearClassName: "",
      linearBox: null,
    };
  },
  props: {
    className: {
      type: String,
      default: "",
    },
    linear: {
      type: Boolean,
      default: false,
    },
    linearBoxName: {
      type: String,
      default: "",
    },
    color: {
      type: String,
      default: "#3a3a3a",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    this.border_circle();
  },
  methods: {
    btn_click() {
      this.$emit("btnClick");
    },
    border_circle() {
      let timer = null;
      if (this.$refs.borderCircle) {
        let $round = $(this.$refs.round);
        let roundRadius = $round.find("circle").attr("r");
        let roundPercent = $round.data("percent");
        let roundCircum = 2 * roundRadius * Math.PI;
        let roundDraw = (roundPercent * roundCircum) / 100;

        $(this.$refs.vBtn).hover(
          () => {
            $round
              .css("stroke-dasharray", roundDraw + " 1000")
              .find("circle")
              .css("opacity", 1);
          },
          () => {
            $round.css("stroke-dasharray", "0 1000");
            clearTimeout(timer);
            timer = setTimeout(() => {
              $round.find("circle").css("opacity", "");
            }, 460);
          }
        );
      }
    },

    hex_to_rgb(hex) {
      var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
      result = result && {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16),
      };

      return result ? `rgba(${result.r}, ${result.g}, ${result.b}, 0.7)` : null;
    },
  },
};
</script>

<style lang="scss">
.v-btn {
  -webkit-tap-highlight-color: transparent;
  background-color: transparent;
  border: 0;
  font-family: inherit;
  cursor: pointer;
  @include flex(center);

  &:not(:disabled):not(.linear-btn):hover {
    i,
    span {
      color: #003893;
    }
  }
  &:focus,
  &:active {
    outline: none;
  }

  &:disabled {
    opacity: 0.4;
    box-shadow: none;
    pointer-events: none;
    cursor: default;
  }

  i {
    color: $color-icon;
    transition: all 0.35s ease;
  }
}

//  线性
.linear-btn {
  position: relative;
  width: 50px;
  height: 50px;
  @include flex(center, center);
  i {
    padding: 0;
    color: inherit !important;
  }
}

.border-circle {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  width: 50px;
  height: 50px;
  text-align: center;
  border: 1px solid $color-icon;
  border-radius: 50%;
  background: transparent;

  svg {
    position: absolute;
    top: -1px;
    left: -1px;
    transition: all 0.45s ease-in-out;
    stroke-dasharray: 0 1000;
  }

  circle {
    fill: transparent;
    stroke: #3a3a3a;
    stroke-width: 1;
    stroke-linecap: round;
    transform-origin: center;
    transform: rotate(-90deg);
    opacity: 0;
  }
}
</style>
